<template>
   <PageFrameContainer>
      <Loader v-if="checking === true">Checking ...</Loader>
      <div v-else>
         <div v-if="artefactExist === true">
            <h1>
               Downloading {{product|productNameFilter}}<sup>&#169;</sup> for Windows {{platform|platformTitleFilter}}
            </h1>
            <h2>Thanks! Your download will start in few seconds...
               <br><br>If not
               <a :href="link" target="_blank">click here</a>
            </h2>
         </div>
         <div v-else>
            <h1>
               Sorry, the requested file is not available, try again later!
            </h1>
         </div>
      </div>
   </PageFrameContainer>
</template>

<script>
    import PageFrameContainer from "./components/PageFrameContainer";
    import runtimeInfo from "./configs/runtimeInfo";
    import Loader from "./components/Loader";

    let artefactDb = require('./assets/data/db');
    export default {
        name: "DownloadPage",
        components: {PageFrameContainer,Loader},
        props: ["product", "version", "platform", "installerType", "link"],
       data: function () {
          return {
             artefactExist: false,
             checking: true
          }
       },
        created: function () {
        },
        mounted: async function () {
            let db = artefactDb;
            let artefactId;
            let link = "";
            for (let item of db[this.product][this.platform][this.installerType]) {
                if (item.ver === this.version) {
                    link = item.link;
                    artefactId = item.id;
                }
            }
            this.link = link;
            try {
                console.info(link);
                let checkReq = await window.fetch(link,
                    {
                        method: 'HEAD',
                        cache: 'no-cache',
                        mode: 'cors'
                    });
                if (!(checkReq.ok || checkReq.status == 200)) {
                    this.artefactExist = false;
                    return;
                }
                this.artefactExist = true;
            } catch (e) {
                console.warn(`Файла ${this.product}.${this.version}  link: '${link}' нет в хранилище!`);
                this.artefactExist = false;
                return;
            }
            finally {
               this.checking=false;
            }
            window.open(this.link, '_blank');
            if (artefactId != null) {
                if (runtimeInfo.isProduction) {
                    try {
                        await window.fetch(`https://api.stats.oneblending.com/artefacts/push?artefactId=${artefactId}`,
                            {
                                method: 'POST',
                                mode: 'cors',
                                keepalive: true
                            });
                    } catch {
                        console.warn();
                    }
                } else {
                    console.info(`simulate stat push to artefact "${artefactId}"`);
                }
            }
            /*let a = document.createElement("a");
            //a.download
            // safari doesn't support this yet
            //if (typeof a.download === 'undefined') {
            // window.location = this.link;
            //} else {
            a.href = this.link;
            a.rel="external";
            document.body.appendChild(a);
            a.click();
            */
            //}
            // let response = await window.fetch(this.link);
            // let router = this.$router;
            // if (response.status !== 200) {
            //     await router.push('/unavailable');
            //     return;
            // }
            // let filename = this.product  + "_" + this.version + "_" + this.platform;
            /*let disposition = response.headers.get("Content-Disposition");
            if (disposition && disposition.indexOf('attachment') !== -1) {
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);
                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                    alert(`filename content-disp ${filename}`);
                }
            }*/
            // let fileData = await response.blob();
            // if (typeof window.navigator.msSaveBlob !== 'undefined') {
            //     // IE workaround for "HTML7007: One or more blob URLs were revoked by closing the blob for which they were created. These URLs will no longer resolve as the data backing the URL has been freed."
            //     window.navigator.msSaveBlob(fileData, filename);
            // } else {
            //     let URL = window.URL || window.webkitURL;
            //     let downloadUrl = URL.createObjectURL(fileData);
            //     if (filename) {
            //         // use HTML5 a[download] attribute to specify filename
            //         let a = document.createElement("a");
            //         // safari doesn't support this yet
            //         if (typeof a.download === 'undefined') {
            //             window.location = downloadUrl;
            //         } else {
            //             a.href = downloadUrl;
            //             a.download = filename;
            //             document.body.appendChild(a);
            //             a.click();
            //         }
            //     } else {
            //         window.location = downloadUrl;
            //     }
            //
            //     setTimeout(function () {
            //         URL.revokeObjectURL(downloadUrl);
            //     }, 100); // cleanup
            //     if (response.status != 200)
            //         await router.push('/unavailable');
            // }
        },
        filters: {
            platformTitleFilter(value) {
                switch (value.toLowerCase()) {
                    case "winx86":
                        return "";

                    default:
                        return "64 bit";

                }
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "/theme/theme.scss";

    h1 {
        padding-top: 1em;
        margin-right: auto;
        margin-left: auto;
        justify-self: center;
        color: $primary80;
        font-size: 2.3rem;
        font-weight: 300;
    }

    sup {
        font-size: 0.5em;
        margin-left: 0.2em;
    }

    h2 {
        padding-top: 2em;
        margin-right: auto;
        margin-left: auto;
        justify-self: center;
        font-size: 1.6rem;
        font-weight: 300;
    }

    a {
        text-decoration: none;
        color: $primary100;
        cursor: pointer;
    }

    a:hover {
        text-decoration: none;
        color: $primary20;
    }
</style>